import ReportIcon from "./images/icons/DangerTriangle.svg?react";
import HideIcon from "./images/icons/eye.svg?react";
import ShareIcon from "@/common/images/icons/share-red.svg?react";
import CollectionIcon from "./images/icons/bookmark.svg?react";
import ManageIcon from "@/common/images/icons/manage_icon.svg?react";
import StackIcon from "@/common/images/icons/stack.svg?react";
import GearIcon from "./images/icons/gear.svg?react";
import FlagIcon from "./images/icons/flag.svg?react";
import { Roles } from "@/common/buses/popups/popup-types";
import { IGif } from "@/common/services/types";
import { CurrentUserObject } from "@/common/hooks/useVisitorInfo";

interface IOptions {
  actions: {
    handleHideGif: () => void;
    handleManageClick: () => void;
    toggleCollection: () => void;
    toggleReport: () => void;
    toggleShareMenu: () => void;
    handleOpenEditNichesDialog: (role: Roles) => void;
    handleOpenEditGif: () => void;
    handleOpenTagFeedback: () => void;
    toggleGifPrefs: () => void;
    toggleNiche: () => void;
  };
  currentUser: CurrentUserObject | null;
  gif: IGif;
  isNicheContentModerator: boolean;
  isFeedbackEnabled: boolean;
}

export const getMoreMenuData = ({ actions, currentUser, gif, isNicheContentModerator, isFeedbackEnabled }: IOptions) => {
  const {
    handleHideGif,
    handleManageClick,
    toggleCollection,
    toggleReport,
    toggleShareMenu,
    handleOpenEditNichesDialog,
    handleOpenEditGif,
    handleOpenTagFeedback,
    toggleGifPrefs,
    toggleNiche,
  } = actions;

  const isAuth = !!currentUser;
  const isCM = !!currentUser?.isContentManager();
  const isThisUserGif = isAuth && gif.userName === currentUser?.username;
  const isGifPublished = gif.published === true;

  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: ShareIcon,
          title: "Share",
          onClick: toggleShareMenu
        },
        ...(isAuth ? [{
          icon: StackIcon,
          title: "Add to a niche",
          onClick: toggleNiche,
          disabled: !isGifPublished
        }] : []),
        ...(isThisUserGif && gif.niches.length > 0 ? [{
          icon: ManageIcon,
          title: "Change niches",
          disabled: !isGifPublished,
          onClick: () => handleOpenEditNichesDialog(Roles.owner),
        }] : []),
        ...(isAuth && !isThisUserGif && isNicheContentModerator ? [{
          icon: ManageIcon,
          title: "Change niches",
          onClick: () => handleOpenEditNichesDialog(Roles.moderator),
        }] : []),
        ...(isAuth ? [{
          icon: CollectionIcon,
          title: "Add to a collection",
          onClick: toggleCollection
        }] : []),
        {
          icon: ReportIcon,
          title: "Report",
          onClick: toggleReport
        },
        ...(isAuth && isFeedbackEnabled ? [{
          icon: FlagIcon,
          title: "Flag Irrelevant Tags",
          onClick: handleOpenTagFeedback
        }] : []),
        ...(isCM ? [{
          icon: HideIcon,
          title: "Hide",
          onClick: handleHideGif
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Change niches",
          onClick: () => handleOpenEditNichesDialog(Roles.admin),
        }] : []),
        ...(isCM ? [{
          icon: GearIcon,
          title: "Type",
          onClick: toggleGifPrefs,
        }] : []),
        ...(isThisUserGif ? [{
          icon: ManageIcon,
          title: "Manage",
          onClick: handleManageClick,
        }] : []),
        ...(isThisUserGif && currentUser.verified ? [{
          icon: ManageIcon,
          title: "Manage Links",
          onClick: () => handleOpenEditGif(),
        }] : []),
      ]
    }
  ];
};
